var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeposit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Deposit_icon",
    "data-name": "Deposit icon",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 32,
    height: 32,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M10.206,27.1H5.22l.13-.669.665-3.46a7.986,7.986,0,0,1-3.97-6.615,6.746,6.746,0,0,1,.18-1.557A3.515,3.515,0,0,1,.49,13.658a2.48,2.48,0,0,1-.426-2.071.779.779,0,1,1,1.526.316.916.916,0,0,0,.139.809,2.041,2.041,0,0,0,1.017.613,8.488,8.488,0,0,1,2.169-2.77A7.276,7.276,0,0,0,15.56,8.025l.01,0A4.977,4.977,0,0,1,19.7,6.033a6.006,6.006,0,0,1,1.6.205.924.924,0,0,1,.643.4.905.905,0,0,1-.118.846l-.939,1.692-.048.087-.128.229-.017.03-.305.552A8.453,8.453,0,0,1,23.517,14.2a1,1,0,0,1,.13.016c2.227.411,2.546,1.742,2.357,4.052-.178,2.169-1.027,2.442-4.244,3.143A10.709,10.709,0,0,1,18,23.952l.606,3.142-4.987,0-.339-2.175c-.1,0-.206,0-.33,0a13.827,13.827,0,0,1-2.378-.2L10.207,27.1h0Zm6.8-13.862a1.558,1.558,0,1,0,1.557-1.559A1.56,1.56,0,0,0,17.006,13.234ZM4.5,4.628A4.627,4.627,0,1,1,9.129,9.256,4.627,4.627,0,0,1,4.5,4.628Z",
    transform: "translate(3.432 2.644)",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposit);
export default __webpack_public_path__ + "static/media/deposit.059dbe40.svg";
export { ForwardRef as ReactComponent };